var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-loading"},[_c('i',{staticClass:"fas fa-spinner fa-spin"}),_vm._v(" "+_vm._s(_vm.tt('please_wait'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }